import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import * as moment from "moment";

@Component({
    selector: "date-filter",
    template: `
        <div class="filter-container flex-column sm:flex-row">
            <div class="date-buttons justify-content-center sm:justify-content-start flex-grow-1 sm:flex-grow-0">
                <span class="p-buttonset m-buttonset-rounded mr-2">
                    <p-button allowOffline icon="pi pi-angle-left" class="angle-left" [disabled]="lockButtons" (onClick)="_move(false)"></p-button>
                    <p-button allowOffline icon="pi pi-angle-right" class="angle-right" [disabled]="lockButtons" (onClick)="_move(true)"></p-button>
                </span>

                <m-select-date
                    allowOffline
                    [ngModel]="currentDate"
                    [disabled]="lockButtons"
                    (ngModelChange)="setDate($event)"
                    [ngModelOptions]="{ standalone: true }"></m-select-date>
            </div>

            <div class="flex flex-1 date-title">
                <label class="m-0 h2-label" style="line-height: 1.5">{{ formattedCurrentDate }}</label>
            </div>
        </div>
    `,
    styleUrls: ["./date-filter.component.scss"]
})
export class DateFilterComponent implements OnInit {
    private _currentDate: Date;
    private _formattedCurrentDate: string;

    @Input() dateFormat = "dddd, Do MMMM YYYY";
    @Input() lockButtons: boolean = false;
    @Input() initialDate: Date = null;

    @Output() readonly dateChanged = new EventEmitter<Date>();

    get currentDate() {
        return this._currentDate;
    }
    get formattedCurrentDate() {
        return this._formattedCurrentDate;
    }

    ngOnInit() {
        const date = this.initialDate ?? new Date();
        this.setDate(date);
    }

    setDate(dt: Date, emitEvent = true) {
        this._currentDate = dt;
        this._formattedCurrentDate = dt ? moment(dt).format(this.dateFormat) : null;
        if (emitEvent) {
            this.dateChanged.emit(dt);
        }
    }

    _move(forward: boolean) {
        this.setDate(
            moment(this.currentDate)
                .add(forward ? 1 : -1, "day")
                .toDate()
        );
    }
}
